import linkageTypeLabels from './linkageTypeLabels'
import { Box, Tab, Tabs } from '@mui/material'
import { VINCULACION_TABS, getVinculacionTab, isMassiveTab, matchesVinculacionFilters } from './vinculacionTabs'
import  { useContext, useEffect, useMemo, useState } from 'react';
import {  Select } from '../../../../ui';
import TableVinculaciones from './TableVinculaciones';
import Plantillas from './Plantillas';
import GlobalContext from '../../../../../../context/global-context';
import businessApi from '../../../../../../api/business.api';
import {monthsOptions as months,currentYear, getYearsOptionsFromFirstLast, getLatestMovementMonth} from '../../../../../utils/constant'
import CustomButton from '../../../../ui/CustomButton';
import CustomPagination from '../../../../table/CustomPagination';
import SearchFilter from '../../../../ui/SearchFilter';
import { ExportXLS } from '../../../../table/ExportData'
import LoaderAdm from '../../../../../../assets/svgIcons/LoaderAdm.json'
import Lottie from 'lottie-react'
import { formatDate, formatRut } from '../../../../../utils/formatter';
import QuestionIcon from '@mui/icons-material/HelpOutline'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles'
import {
  migrateLegacyMassivePeriodTraces,
  persistMassivePeriodTraces
} from './massivePeriodTrace.storage'
import { CENTRO_COSTO_FILTER_OPTIONS } from '../centroCostoFilter'
import { useAdministracionTabs } from '../../../../../../pages/useAdministracion.hooks'

const monthNames = ['enero','febrero','marzo','abril','mayo','junio', 'julio','agosto','septiembre','octubre','noviembre','diciembre' ]

const massiveLinkageTypeOptions = [
  { value: 'pago-masivo', label: 'Pago Masivo' },
  { value: 'cobro-masivo', label: 'Cobro Masivo' }
]
const massiveLinkageTypeValues = new Set(massiveLinkageTypeOptions.map(option => option.value))
const customsAgentCurrentAccountOption = {
  value: 'cuenta-corriente-agente-aduana',
  label: 'Cuenta Corriente Agente de Aduana'
}
const frontendOnlyLinkageTypeValues = new Set([
  ...massiveLinkageTypeValues,
  customsAgentCurrentAccountOption.value
])

const normalizeLinkageTypeOptions = payload => {
  const candidates = Array.isArray(payload)
    ? payload
    : payload?.linkageTypes ?? payload?.types ?? payload?.content ?? payload?.data ?? []
  const rows = Array.isArray(candidates) ? candidates : []

  return rows.reduce((options, item) => {
    const rawValue = typeof item === 'object'
      ? item?.value ?? item?.folioCredito ?? item?.linkageType ?? item?.code ?? item?.id
      : item
    const value = rawValue == null ? '' : String(rawValue)
    if (!value || options.some(option => option.value === value)) return options

    const rawLabel = typeof item === 'object'
      ? item?.label ?? item?.nombre ?? item?.name ?? item?.nombreFolio ?? item?.descripcion
      : item
    options.push({ value, label: String(rawLabel ?? linkageTypeLabels[value] ?? value) })
    return options
  }, [])
}

const toMovementArray = payload => {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.libros)) return payload.libros
  if (Array.isArray(payload?.content)) return payload.content
  if (payload && typeof payload === 'object') {
    return Object.values(payload)
      .flat()
      .filter(item => item && typeof item === 'object')
  }
  return []
}

const getDinRevAmount = row => {
  if (Number(row?.code) === 914) {
    return Number(row?.montoIvaRetenido ?? 0) || 0
  }

  return (
    Number(
      row?.montoTotal ??
        row?.monto ??
        row?.montoRelacionado ??
        row?.montoCargo ??
        row?.montoAbono ??
        row?.debe ??
        row?.haber ??
        0
    ) || 0
  )
}

const buildDinRevVirtualMovement = (
  rows,
  rawResponseData,
  businessId,
  year,
  totalCuentaCorrienteAgenteAduana
) => {
  if (!rows.length) return null

  const validDates = rows
    .map(row => row?.fecha ?? row?.createdAt)
    .filter(Boolean)
    .map(value => new Date(value))
    .filter(date => !Number.isNaN(date.getTime()))
    .sort((a, b) => b.getTime() - a.getTime())
  const fallbackDate = new Date(`${year}-01-01T12:00:00`)
  const latestDate = validDates[0] || fallbackDate
  const montoDocumentos = rows.reduce((total, row) => total + getDinRevAmount(row), 0)
  const totalObjetivo = Number(totalCuentaCorrienteAgenteAduana) || 0
  const estaConciliado = montoDocumentos >= totalObjetivo - 0.01

  return {
    id: `din-rev-${businessId}-${year}`,
    idPrincipal: `din-rev-${businessId}-${year}`,
    _isDinRevVirtual: true,
    _dinRevDocuments: rows,
    _dinRevResponseData: rawResponseData,
    fecha: latestDate.toISOString(),
    folioCredito: 29,
    numeroFolio: '',
    comprobante: '',
    razonSocial: '',
    rut: '',
    nombreCuenta: '',
    codigoCuenta: '',
    montoTotal: montoDocumentos,
    status: estaConciliado ? 'CONCILIADO' : 'PARCIALMENTE PAGADO',
    nombreOrigen: 'manual',
    usuarioClasificador: ''
  }
}

const buildTraceRelatedIds = trace => {
  if (!trace) return []

  const rawIds = [
    ...(Array.isArray(trace?.relatedIds) ? trace.relatedIds : []),
    ...(Array.isArray(trace?.selectedIds) ? trace.selectedIds : []),
    ...(Array.isArray(trace?.documents)
      ? trace.documents.flatMap(item => [item?.id, item?.idPrincipal])
      : [])
  ]

  return [...new Set(rawIds.map(Number).filter(Number.isFinite))]
}

const hasSameIds = (leftIds, rightIds) => {
  if (leftIds.length !== rightIds.length) return false

  const leftKey = [...leftIds].sort((a, b) => a - b).join('|')
  const rightKey = [...rightIds].sort((a, b) => a - b).join('|')

  return leftKey === rightKey
}

const buildNextMassivePeriodTraces = (currentTraces, normalizedTrace) => [
  normalizedTrace,
  ...currentTraces.filter(trace => {
    const sameSource = trace?.source === normalizedTrace.source
    const sameMonth =
      Number(trace?.filterContext?.monthFilter || 0) ===
      Number(normalizedTrace?.filterContext?.monthFilter || 0)
    const sameYear =
      Number(trace?.filterContext?.yearFilter || 0) ===
      Number(normalizedTrace?.filterContext?.yearFilter || 0)

    return !(
      sameSource &&
      sameMonth &&
      sameYear &&
      hasSameIds(buildTraceRelatedIds(trace), normalizedTrace.relatedIds)
    )
  })
].slice(0, 30)

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#000033',
      color: '#ffff',
      fontSize: '0.75rem',
      padding: '6px 12px',
      borderRadius: '6px',
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: '#000033',
    },
  }));

const List = () => {
  const [movementTab, setMovementTab] = useState('abono')
  const [massiveVisibleRows, setMassiveVisibleRows] = useState([])
  const [monthFilter, setMonthFilter] = useState('')
  const [latestMovementMonth, setLatestMovementMonth] = useState(null)
  const [yearFilter, setYearFilter] = useState(currentYear)
  const [data, setData] = useState([])
  const [linkageTypeFilter, setLinkageTypeFilter] = useState('')
  const [centroCostoFilter, setCentroCostoFilter] = useState('')
  const [debouncedDescripcion, setDebouncedDescripcion] = useState('')
  const [highlightedRows, setHighlightedRows] = useState({})
  const [, setUpdateData] = useState(false);
  const { currentBusiness, firstLast } = useContext(GlobalContext)
  const { activeTab } = useAdministracionTabs()
  const yearOptions = useMemo(
    () => getYearsOptionsFromFirstLast(firstLast.data, currentBusiness?.createdAt),
    [firstLast.data, currentBusiness?.createdAt]
  )
  const [rowsPerPage, setRowsPerPage] = useState(-1)
  const [, setInitialFilterDocumento] = useState([])
  const [showFilters] = useState(true)
  const [switchGetData, setSwitchGetData] = useState(false)
  const [page, setPage] = useState(0)
  const [selectedFilter, setSelectedFilter] = useState('')
  const [filterValues, setFilterValues] = useState({ montoDesde: '', montoHasta: '', descripcion: '' })
  const [order, setOrder] = useState({ col: '', field: '', direction: 'asc' })
  const [isLoadingData, setIsLoadingData] = useState(true)
  const [massivePeriodTraces, setMassivePeriodTraces] = useState([])
  const [isMassivePeriodTraceHydrated, setIsMassivePeriodTraceHydrated] = useState(false)
  const [availableMassiveTypes, setAvailableMassiveTypes] = useState([])
  const [linkageTypeOptions, setLinkageTypeOptions] = useState([])
  const [isLoadingLinkageTypes, setIsLoadingLinkageTypes] = useState(false)
  const [dinRevTemplateState, setDinRevTemplateState] = useState({
    status: 'loading',
    documents: [],
    responseData: null
  })

  const today    = new Date()
  const yearNum  = today.getFullYear()
  const monthNow = today.getMonth() + 1

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedDescripcion(filterValues.descripcion)
    }, 300)

    return () => clearTimeout(timer)
  }, [filterValues.descripcion])

  useEffect(() => {
    if (!firstLast.isLoading && !yearOptions.some(option => option.value === Number(yearFilter))) {
      setYearFilter(currentYear)
    }
  }, [firstLast.isLoading, yearFilter, yearOptions])

  useEffect(() => {
    setLatestMovementMonth(null)
  }, [currentBusiness?.id, yearFilter])

  useEffect(() => {
    setAvailableMassiveTypes([])
  }, [currentBusiness?.id, monthFilter, yearFilter])

  useEffect(() => {
    let isMounted = true

    const fetchLinkageTypes = async () => {
      if (!currentBusiness?.id) {
        setLinkageTypeOptions([])
        return
      }

      setIsLoadingLinkageTypes(true)
      try {
        const response = await businessApi.getLinkageTypes({
          businessId: Number(currentBusiness.id),
          year: Number(yearFilter) || yearNum,
          month: Number(monthFilter) || 0
        })
        if (isMounted) setLinkageTypeOptions(normalizeLinkageTypeOptions(response?.data))
      } catch (error) {
        console.error('[Vinculaciones] Error al consultar tipos de vinculacion', error)
        if (isMounted) setLinkageTypeOptions([])
      } finally {
        if (isMounted) setIsLoadingLinkageTypes(false)
      }
    }

    fetchLinkageTypes()
    return () => {
      isMounted = false
    }
  }, [currentBusiness?.id, monthFilter, yearFilter, yearNum])

  const getData = async () => {
  if (!currentBusiness?.id) {
    setData({})
    setInitialFilterDocumento([])
    setDinRevTemplateState({ status: 'empty', documents: [], responseData: null })
    setIsLoadingData(false)
    return
  }

  setUpdateData(true)
  setDinRevTemplateState(current => ({ ...current, status: 'loading' }))

  const selectedYear = Number(yearFilter) || yearNum

  const grouped = {}
  for (let i = 0; i < 12; i++) {
    grouped[monthNames[i]] = []
  }

  try {
    const [resp, dinRevResponse, anticiposResponse, devolucionesResponse] = await Promise.all([
      businessApi.getListSummaryVinculos({
        businessId: currentBusiness.id,
        month: 0,       // 0 = todos los meses
        year: Number(selectedYear),
        linkage: undefined,
        linkageType: frontendOnlyLinkageTypeValues.has(linkageTypeFilter)
          ? undefined
          : linkageTypeFilter || undefined,
        centroCosto: centroCostoFilter || undefined,
        // La b?squeda local incluye el nombre asociado a folioCredito.
        status:
          selectedFilter && selectedFilter !== 'destacados' ? selectedFilter : undefined
      }),
      businessApi.getListSummaryMovementsSpecific({
        businessId: currentBusiness.id,
        type: 'din-rev',
        month: 0,
        year: Number(selectedYear),
        max: 30,
        page: 0,
        linkage: true,
        aprobadoMin: -5
      }).catch(error => {
        console.error('[Vinculaciones] Error al consultar movimientos din-rev', error)
        return { data: null, dinRevLookupFailed: true }
      }),
      businessApi.getListSummaryVinculos({
        businessId: currentBusiness.id,
        month: 0,
        year: Number(selectedYear),
        linkage: undefined,
        linkageType: '27'
      }).catch(error => {
        console.error('[Vinculaciones] Error al consultar anticipos de agente de aduana', error)
        return { data: [] }
      }),
      businessApi.getListSummaryVinculos({
        businessId: currentBusiness.id,
        month: 0,
        year: Number(selectedYear),
        linkage: undefined,
        linkageType: '30'
      }).catch(error => {
        console.error('[Vinculaciones] Error al consultar devoluciones de agente de aduana', error)
        return { data: [] }
      })
    ])

    let data = resp.data

    // ───────── MANEJO ROBUSTO ─────────
    if (!data) data = []

    if (!Array.isArray(data) && typeof data === "object") {
      data = Object.values(data).flat()
    }

    if (!Array.isArray(data)) data = []

    const responseLatestMonth = getLatestMovementMonth(data, selectedYear)
    setLatestMovementMonth(current => Math.max(current ?? 0, responseLatestMonth))

    const dinRevResponseData = dinRevResponse?.data
    const dinRevDocuments = toMovementArray(dinRevResponseData)
    setDinRevTemplateState({
      status: dinRevResponse?.dinRevLookupFailed
        ? 'error'
        : dinRevDocuments.length > 0
          ? 'existing'
          : 'empty',
      documents: dinRevDocuments,
      responseData: dinRevResponseData
    })
    const totalAnticiposAgenteAduana = toMovementArray(anticiposResponse?.data)
      .filter(item => Number(item?.folioCredito) === 27)
      .reduce((total, item) => total + Math.abs(getDinRevAmount(item)), 0)
    const totalDevolucionesAgenteAduana = toMovementArray(devolucionesResponse?.data)
      .filter(item => Number(item?.folioCredito) === 30)
      .reduce((total, item) => total + Math.abs(getDinRevAmount(item)), 0)
    const totalCuentaCorrienteAgenteAduana =
      totalAnticiposAgenteAduana - totalDevolucionesAgenteAduana
    const dinRevMovement = buildDinRevVirtualMovement(
      dinRevDocuments,
      dinRevResponseData,
      currentBusiness.id,
      selectedYear,
      totalCuentaCorrienteAgenteAduana
    )
    const shouldIncludeDinRevMovement =
      !linkageTypeFilter ||
      linkageTypeFilter === customsAgentCurrentAccountOption.value
    if (dinRevMovement && shouldIncludeDinRevMovement) data.push(dinRevMovement)

    // ───────── AGRUPAR POR FECHA REAL ─────────
    data.forEach(item => {
      if (!item.fecha) return

      const fecha = new Date(item.fecha)
      if (isNaN(fecha.getTime())) return

      // La API puede incluir movimientos manuales fuera del período solicitado.
      // Se valida también en cliente para que todos respeten el año seleccionado.
      if (fecha.getUTCFullYear() !== selectedYear) return

      // Extraer mes en UTC (porque fecha viene con Z)
      const mesNumero = fecha.getUTCMonth() + 1  // 1–12

      // Validar rango
      if (mesNumero < 1 || mesNumero > 12) return

      const nombreMes = monthNames[mesNumero - 1]

      // Agrupar siempre dentro de los 12 meses del año seleccionado
      if (grouped[nombreMes]) {
        grouped[nombreMes].push(item)
      }
    })

  } catch (e) {
    console.error(e)
    setDinRevTemplateState({ status: 'error', documents: [], responseData: null })
  }

  // Guardar data agrupada
  setData(grouped)

  // ───────── FILTROS DE DOCUMENTOS ─────────
  const allFlat = Object.values(grouped).flat()

  const foliosUnicos = Array.from(
    new Set(
      allFlat
        .map(i => i.nombreFolio || i.nombreCuenta)
        .filter(Boolean)
    )
  )

  setInitialFilterDocumento([
    { value: "", label: "Todos los documentos" },
    ...foliosUnicos.map(f => ({
      value: f,
      label: f === "Boleta" ? "Boleta de Honorarios" : f,
    })),
  ])

  setUpdateData(false)
  setIsLoadingData(false)
}

  useEffect(() => {
    if (activeTab !== 'vinculaciones') return
    setIsLoadingData(true)
    getData()
  }, [activeTab, currentBusiness?.id, yearFilter, linkageTypeFilter, centroCostoFilter, selectedFilter])

  useEffect(() => {
    if (!switchGetData) return
    setIsLoadingData(true)
    getData()
    setSwitchGetData(false)
  }, [switchGetData])

  useEffect(() => {
    let isMounted = true

    const hydrateMassivePeriodTraces = async () => {
      if (!currentBusiness?.id) {
        if (!isMounted) return
        setMassivePeriodTraces([])
        setIsMassivePeriodTraceHydrated(false)
        return
      }

      setIsMassivePeriodTraceHydrated(false)

      const storedTraces = await migrateLegacyMassivePeriodTraces(currentBusiness.id)
      if (!isMounted) return

      setMassivePeriodTraces(Array.isArray(storedTraces) ? storedTraces : [])
      setIsMassivePeriodTraceHydrated(true)
    }

    hydrateMassivePeriodTraces()

    return () => {
      isMounted = false
    }
  }, [currentBusiness?.id])

  useEffect(() => {
    if (!currentBusiness?.id || !isMassivePeriodTraceHydrated) return

    const syncMassivePeriodTraces = async () => {
      await persistMassivePeriodTraces(currentBusiness.id, massivePeriodTraces)
    }

    syncMassivePeriodTraces()
  }, [currentBusiness?.id, isMassivePeriodTraceHydrated, massivePeriodTraces])

  // destacados
  useEffect(() => {
    setUpdateData(true)
    const saved = JSON.parse(localStorage.getItem('highlightedRows') || '{}')
    setHighlightedRows(saved)
  }, [])

  const monthsOptions = useMemo(() => [
    { value: '', label: 'Todos los meses' },
    ...months.map(opt => ({
      ...opt,
      disabled: Number(opt.value) > Math.max(
        Number(yearFilter) < yearNum
          ? 12
          : Number(yearFilter) === yearNum
            ? monthNow
            : 0,
        latestMovementMonth ?? 0
      )
    }))
  ], [latestMovementMonth, monthNow, yearFilter, yearNum])

  // datos para tabla
  const rowsForTable = useMemo(() => {
    if (monthFilter) {
      const idx = Number(monthFilter) - 1
      return data[monthNames[idx]] || []
    }
    return Object.values(data).flat()
  }, [data, monthFilter])

  const linkageTypeFilterOptions = useMemo(() => {
    const uniqueTypes = new Map()

    linkageTypeOptions.forEach(option => {
      uniqueTypes.set(option.value, option)
    })

    massiveLinkageTypeOptions.forEach(option => {
      uniqueTypes.set(option.value, option)
    })

    const sortedOptions = Array.from(uniqueTypes.values()).sort((a, b) =>
      a.label.localeCompare(b.label, 'es', { sensitivity: 'base' })
    )
    const anticipoIndex = sortedOptions.findIndex(option => option.value === '27')
    sortedOptions.splice(anticipoIndex >= 0 ? anticipoIndex + 1 : 0, 0, customsAgentCurrentAccountOption)

    return [
      { value: '', label: 'Tipo de vinculacion' },
      ...sortedOptions.filter(option => getVinculacionTab({
        folioCredito: option.value,
        linkageType: option.value,
        _isDinRevVirtual: option.value === customsAgentCurrentAccountOption.value
      }) === movementTab)
    ]
  }, [availableMassiveTypes, linkageTypeOptions, movementTab])

  useEffect(() => {
    if (
      linkageTypeFilter &&
      !isLoadingLinkageTypes &&
      !frontendOnlyLinkageTypeValues.has(linkageTypeFilter) &&
      !linkageTypeFilterOptions.some(option => option.value === linkageTypeFilter)
    ) {
      setLinkageTypeFilter('')
    }
  }, [isLoadingLinkageTypes, linkageTypeFilter, linkageTypeFilterOptions])

  const filteredData = useMemo(() => {
    let result = rowsForTable.filter(item => getVinculacionTab(item) === movementTab)
    result = result.filter(item => matchesVinculacionFilters(item, {
      descripcion: debouncedDescripcion,
      montoDesde: filterValues.montoDesde, montoHasta: filterValues.montoHasta
    }))

    if (linkageTypeFilter === customsAgentCurrentAccountOption.value) {
      result = result.filter(item => item?._isDinRevVirtual === true)
    }

    if (selectedFilter === 'destacados') result = result.filter(i => highlightedRows[i.id])

    return result
  }, [rowsForTable, linkageTypeFilter, selectedFilter, highlightedRows, movementTab, debouncedDescripcion, filterValues.montoDesde, filterValues.montoHasta])

  const toggleHighlight = id => {
    setHighlightedRows(prev => {
      const next = { ...prev, [id]: !prev[id] }
      localStorage.setItem('highlightedRows', JSON.stringify(next))
      return next
    })
  }

  const handleMassivePeriodTrace = tracePayload => {
    if (!currentBusiness?.id || !tracePayload) return

    const normalizedTrace = {
      ...tracePayload,
      businessId: currentBusiness.id,
      relatedIds: buildTraceRelatedIds(tracePayload),
      createdAt: new Date().toISOString()
    }

    setMassivePeriodTraces(prev => {
      const currentTraces = Array.isArray(prev) ? prev : []
      return buildNextMassivePeriodTraces(currentTraces, normalizedTrace)
    })

    setIsMassivePeriodTraceHydrated(true)
  }

  const options = [
    { label: 'Pagado', value: 'pagado' },
    { label: 'Cobrado', value: 'cobrado' },
    { label: 'Por pagar', value: 'porPagar' },
    { label: 'Por cobrar', value: 'porCobrar' },
    { label: 'Parcialmente pagado', value: 'parcialmenteP' },
    { label: 'Parcialmenet cobrado', value: 'parcialmenteC' },
    { label: 'Destacados', value: 'destacados' }
  ]
const handleFilterChange = (k, v) => setFilterValues(prev => ({ ...prev, [k]: v }))

// orden y paginación
  const handleChangePage = p => setPage(p)
  const handleChangeRowsPerPage = r => { setRowsPerPage(r); setPage(0) }
  const handleSort = ({ col, field }) => {
    const asc = order.col === col && order.direction === 'asc'
    setOrder({ col, field, direction: asc ? 'desc' : 'asc' })
    setPage(0)
  }

  const filteredDataSin37 = useMemo(() => {
    return filteredData.filter(item => item.origenTabla !== 37);
  }, [filteredData]);

  const uniqueFilteredData = useMemo(() => {
    return Array.from(
      new Map(
        filteredDataSin37.map((item, index) => {
          const numeroFolio = String(item?.numeroFolio ?? item?.folio ?? '').trim()
          const comprobante = String(item?.comprobante ?? '').trim()
          const fallbackId = item?.idPrincipal ?? item?.id ?? index
          const key = numeroFolio || comprobante
            ? `${numeroFolio}|${comprobante}`
            : `sin-folio-comprobante|${fallbackId}`

          return [key, item]
        })
      ).values()
    );
  }, [filteredDataSin37]);

  const sortedData = useMemo(() => {
    if (!order.field) return uniqueFilteredData

    return [...uniqueFilteredData].sort((a, b) => {
      const A = a[order.field]
      const B = b[order.field]
      if (A == null && B == null) return 0
      if (A == null) return 1
      if (B == null) return -1
      return order.direction === 'asc'
        ? A < B ? -1 : A > B ? 1 : 0
        : A > B ? -1 : A < B ? 1 : 0
    })
  }, [uniqueFilteredData, order.field, order.direction])

  const paginatedData = rowsPerPage > 0
  ? sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  : sortedData

  const isMassive = isMassiveTab(movementTab)
  const totalRows = isMassive ? massiveVisibleRows.length : uniqueFilteredData.length

  useEffect(() => {
    setPage(0)
  }, [movementTab, monthFilter, yearFilter, linkageTypeFilter, centroCostoFilter, selectedFilter, debouncedDescripcion, filterValues.montoDesde, filterValues.montoHasta])

  const dataToExport = (isMassive ? massiveVisibleRows : sortedData).map(item => {
    return {
      Fecha: item.fecha && formatDate(item.fecha),
      'Nombre cuenta': item.nombreCuenta,
      'Codigo cuenta': item.codigoCuenta,
      'Contraparte': item.razonSocial,
      RUT: item.rut && formatRut(item.rut),
      Usuario: ' @' + (item.usuarioClasificador || 'TryLuca'),
      Status: item.status,
    }
  })

  const icons = [
    <ExportXLS
      key='export-xls'
      currentBusiness={currentBusiness.name}
      rut={currentBusiness.rut}
      data={dataToExport}
      title='ingresos'
      year={yearFilter}
      month={monthFilter}
    />, ]

 return (
    <>
    {showFilters && (
      <div className='p-4 bg-white rounded-3xl shadow-full-xs mt-6 relative'>
        <div className="flex flex-col items-start text-start">
          <div className="w-full p-2 rounded-3xl mt-2 relative">
            
            {/* Icono tooltip */}
            <div
              className="absolute top-[-15px] right-2"
              onClick={(e) => e.stopPropagation()} // evita disparar click del div
            >
              <CustomTooltip 
                title="En esta sección podrás crear obligaciones de cobro o de pago para movimientos que no provengan de documentos tributarios. Una vez creadas, podrás conciliar estas con cargos o abonos de banco o caja." 
                arrow
              >
                <QuestionIcon 
                  fontSize="inherit" 
                  className="text-gray-500 cursor-pointer hover:text-primary" 
                  style={{ fontSize: '25px' }} // un poco más grande que small
                />
              </CustomTooltip>
            </div>
  <div className="flex-1 min-w-0">
    <Plantillas
      setSwitchGetData={setSwitchGetData}
      onMassivePeriodTrace={handleMassivePeriodTrace}
      dinRevTemplateState={dinRevTemplateState}
    />
  </div>
          </div>
        </div>
      </div>
        )}
      <div className="p-4 mt-6 bg-white rounded-3xl shadow-md flex flex-col" style={{ height: 'calc(100vh - 12rem)' }} >
        <Box sx={{ borderBottom: 4, borderColor: 'rgb(var(--border))', mb: 2, flexShrink: 0 }}>
          <Tabs
            value={movementTab}
            onChange={(_, value) => {
              setMovementTab(value)
              setLinkageTypeFilter('')
              setMassiveVisibleRows([])
              setPage(0)
            }}
            aria-label='Tipos de movimientos de vinculacion'
            variant='scrollable'
            scrollButtons='auto'
            sx={{
              minHeight: 48,
              '& .MuiTabs-indicator': { height: 4, borderRadius: '9999px', backgroundColor: 'rgb(var(--primary))' },
              '& .MuiTab-root': {
                minHeight: 48, px: { xs: 1.5, sm: 2.5 }, color: 'rgb(var(--muted))',
                fontFamily: 'Inter, Nunito, system-ui, sans-serif',
                fontSize: { xs: '0.75rem', sm: '0.875rem' }, fontWeight: 500, textTransform: 'none'
              },
              '& .MuiTab-root.Mui-selected': { color: 'rgb(var(--primary))', fontWeight: 700 }
            }}
          >
            {VINCULACION_TABS.map(tab => <Tab key={tab.value} value={tab.value} label={tab.label} />)}
          </Tabs>
        </Box>
        <div className='relative'>
          <div className='relative'>
            <div className='absolute top-[-35px] right-0 z-20 flex items-center space-x-2'>
              {icons.map((icon) => icon)}
            </div>
          </div>
            <div className='flex flex-wrap gap-2 mt-3 items-center rounded-3xl p-4 mb-4'>
                <Select options={monthsOptions} defaultValue={monthFilter} onChange={e => setMonthFilter(e.target.value)} />
                <Select options={yearOptions} value={yearFilter} onChange={(e) => setYearFilter(e.target.value)} />
                <Select value={linkageTypeFilter} options={linkageTypeFilterOptions} onChange={e => setLinkageTypeFilter(e.target.value)} />
                <Select
                  value={centroCostoFilter}
                  options={CENTRO_COSTO_FILTER_OPTIONS}
                  onChange={e => {
                    setCentroCostoFilter(e.target.value)
                    setPage(0)
                  }}
                />
                <SearchFilter value={filterValues.descripcion} onChange={e => handleFilterChange('descripcion', e.target.value)} filterValues={filterValues} onFilterChange={handleFilterChange} />
                <select
                  value={selectedFilter}
                  onChange={e => setSelectedFilter(e.target.value)}
                  className="min-w-[90px] border border-gray-300 hover:border-gray-400 focus:border-gray-400 px-4 py-1 pr-6 rounded-full shadow leading-tight text-sm font-sans"
                >
                  <option value="">Todos</option>
                  {options.map(opt => (
                    <option key={opt.value} value={opt.value} className='font-sans'>
                      {opt.label}
                    </option>
                  ))}
                </select>
                <CustomButton className='rounded-full' color='primary' title='BUSCAR' onClick={getData} />
              </div>
              
          </div>
          {isLoadingData ? (
            <div className="flex items-center justify-center h-full">
              <Lottie animationData={LoaderAdm} loop style={{ width: 300, height: 300 }} />
            </div>
          ) : (
            <>
              <div className="flex-1 min-h-0 overflow-auto overscroll-contain pb-2" style={{ overflowAnchor: 'none' }}>
                <TableVinculaciones 
                  movementTab={movementTab}
                  massivePage={page}
                  onMassiveRowsChange={setMassiveVisibleRows}
                  searchFilters={filterValues}
                  statusFilter={selectedFilter}
                  row={paginatedData} 
                  rowsPerPage={rowsPerPage} 
                  setRowsPerPage={setRowsPerPage}
                  onSort={handleSort}
                  order={order}
                  getData={getData}
                  highlightedRows={highlightedRows}
                  toggleHighlight={toggleHighlight}
                  setSwitchGetData={setSwitchGetData}
                  massivePeriodTrace={massivePeriodTraces}
                  yearFilter={yearFilter}
                  monthFilter={monthFilter}
                  onMassiveTypesChange={setAvailableMassiveTypes}
                  linkageTypeFilter={linkageTypeFilter}
                  centroCostoFilter={centroCostoFilter}
                />
              </div>
           {(totalRows > 0) && (
              <div className="mt-4">
                <CustomPagination
                  count={totalRows}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default List;
